// frontend/src/services/perfisService.js
import axios from 'axios';

const PERFIS_API = 'https://api-jsftfgn6a-uc.a.run.app/buscar-perfis';

export const buscarPerfis = async (busca, estado, cidade) => {
  try {
    const response = await axios.get(PERFIS_API, {
      params: { busca, estado, cidade },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar perfis:', error);
    return [];
  }
};
